import React, { Component } from "react";
import {
  TouchableOpacity,
  StyleSheet,
  Dimensions,
  Platform,
  ScrollView,
  TouchableHighlight,
  View,
  ImageBackground,
} from "react-native";
import Text from "./TextFont";
// import Switch from "../components/ToggleSwitch";
import { connect } from "react-redux";
import ArButton from "../argon-ui/Button";
import { getIconByDeviceType } from "../actions/DeviceHelper";

import Theme from "../argon-ui/Theme";
import { IconButton } from "./Buttons";
import { IS_MOBILE, translate } from "../locales/translate";
import Countdown from "../components/CountDown";
import * as AreaActions from "../actions/AreaActions";
import * as SmartSpeakerActions from "../actions/SmartSpeakerActions";
import * as CONSTANTS from "../../assets/consts";

import * as DeviceTypes from "../components/devices/_deviceTypes";
import * as AreaTypes from "../components/areas/_areaType";
import * as DoorlockActions from "../actions/DoorlockActions";
import * as AreaHelper from "../actions/AreaHelper";
//import DeviceInfo from "react-native-device-info";

import Thermometer from "../components/devices/Thermometer";
import LightMeter from "../components/devices/LightMeter";
import RTSPPlayer from "../components/RTSPPlayer";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import { faTimes } from "../../assets/consts/faCharCodes";
import * as faCharCodes from "../../assets/consts/faCharCodes";

import AppLog from "../logger";
import AreaItem from "./AreaItem";
import MediaPlayer from "../components/MediaPlayer";
import AreaArmItem from "./AreaArmItem";
import useAreaListByAreaType from "../components/areas/useAreaListByAreaType";
import Select from "../nativeBase-ui/Select";
import ModalBase from "../nativeBase-ui/ModalBase";
import { HStack, VStack } from "native-base";
import { getDir, getIsRTL } from "../util";
const axios = require("axios").default;

const SCREEN_WIDTH = Dimensions.get("screen").width;
const WINDOW_WIDTH = Dimensions.get("screen").height;
const HEIGHT_WINDOW = Dimensions.get("window").height;
const IMAGE_SIZE = 48;
const BIG_ARM_CION_SIZE = 200;
const SIRENS_DURATION = [
  {
    label: "5 " + translate("app.minute"),
    value: 5,
  },
  {
    label: "10 " + translate("app.minute"),
    value: 10,
  },
  {
    label: "15 " + translate("app.minute"),
    value: 15,
  },
];
const HEIGHT_CONTAINER = HEIGHT_WINDOW - 31;
/** @augments{Component<props,state>} */
class Area extends Component {
  constructor(props) {
    super(props);
    let { expanded, isKioskMode } = this.props;
    this.state = {
      fontsLoaded: false,
      showArmModal: false,
      armCountDownStarted: false,
      shouldTurnOffLights: true,
      shouldTurnOffAirConditioners: true,
      shouldCheckDoorWindowsClosed: true,
      shouldUnlockAfterDisArm: true,
      devicesToUnlockAfterDisArm: [],
      shouldRunScenarios: true,
      shouldCloseCurtains: true,
      shouldNotifyBreach: true,
      shouldSmsBreach: true,
      shouldTurnOnSirens: true,
      armInProgress: false,
      expanded: expanded || isKioskMode,
      areaStateIcon: null,
      userState: null,
      sirensDuration: 5,
      // showShouldCloseCurtains: true,
      accessToken: "",
      disArmInProgress: false,
      activeDeviceType: null,
      firstLoad: false,
    };
    this.areaModel = undefined;
  }

  componentDidMount() {
    let { currentServer } = this.props.AppReducer;
    const accessToken = currentServer.accessToken;
    this.setState({ accessToken }, () => {
      this.areaModel = AreaHelper.findAreaById(
        this.props.AreaReducer.areas,
        this.props.areaId
      );
      this.getAreaStateIcon();
    });
    this.props.isKioskMode && this.setActiveDevice();
  }

  handleOnItemCounterPress = (deviceType = "UNKNOWN") => {
    if (this.state.activeDeviceType !== deviceType) {
      this.setState({ activeDeviceType: deviceType });
    }
    if (
      this.props.isKioskMode &&
      this.props.selectedAreaDeviceType === DeviceTypes.ELEVATOR
    ) {
      typeof this.props.onUnSubscribeToTopic === "function" &&
        this.props.onUnSubscribeToTopic();
    }
    if (
      this.props.isKioskMode &&
      this.props.selectedAreaDeviceType === DeviceTypes.CAMERA
    ) {
      this.handleSelectedCameraClose();
    }
    if (this.props.isKioskMode && deviceType === AreaTypes.BATHROOM) {
      this.handleOnItemAreaTypeCounterPress(AreaTypes.BATHROOM);
    }
    deviceType &&
      this.props.areaId &&
      this.props.onAreaItemPress &&
      this.props.onAreaItemPress(
        this.props.areaId,
        this.props.areaUId,
        deviceType
      );
  };
  handleOnItemAreaTypeCounterPress = (areaType = "UNKNOWN") => {
    areaType &&
      this.props.areaId &&
      this.props.onAreaTypeItem &&
      this.props.onAreaTypeItem(this.props.areaId, areaType);
  };

  handleOnDoorLockPress = () => {
    this.handleOnItemCounterPress(DeviceTypes.DOORLOCK);
  };

  handleOnAccessControlsPress = () => {
    this.handleOnItemCounterPress(DeviceTypes.ACCESS_CONTROL);
  };
  handleOnMediaPlayerPlayListPress = (
    deviceId,
    deviceUId,
    playListId,
    playListUId
  ) => {
    typeof this.props.onMediaPlayerPlayListPress === "function" &&
      this.props.onMediaPlayerPlayListPress(
        this.props.areaId,
        this.props.areaUId,
        deviceId,
        deviceUId,
        playListId,
        playListUId
      );
  };

  static getDerivedStateFromProps(props, state) {
    if (props.selectedCameraId !== state.selectedCameraId) {
      return {
        selectedCameraId: props.selectedCameraId,
      };
    }

    if (
      props.area.armReport &&
      Array.isArray(props.area.armReport.openWindows) &&
      props.area.armReport.openWindows.length > 0
    ) {
      return {
        //openWindows: [...props.armReport.openWindows],
        armInProgress: false,
      };
    }

    // Return null to indicate no change to state.
    return null;
  }

  handleSelectedCameraClose = () => {
    this.props.onSelectedCameraClose && this.props.onSelectedCameraClose();
  };

  handleSelectedSmartSpeakerClose = () => {
    typeof this.props.onSelectedSmartSpeakerClose === "function" &&
      this.props.onSelectedSmartSpeakerClose();
  };

  handleOnAccessControlOpenAllAreaDoors = () => {
    typeof this.props.onAccessControlUnlockAllAreaDoors === "function" &&
      this.props.onAccessControlUnlockAllAreaDoors();
  };

  renderArmModal = () => {
    if (this.props.area.armReport && this.props.area.armReport.error) {
      return (
        <View style={{ flex: 1, justifyContent: "center" }}>
          <Text style={{ color: "#F00", textAlign: "center" }}>
            {translate(`area.${this.props.area.armReport.error}`)}
          </Text>
        </View>
      );
    }
    if (
      (this.props.area.armReport && this.props.area.armReport.inProgress) ||
      !this.props.area.isArmed
    ) {
      var definedScenarios = [];
      if (this.state.showArmModal) {
        definedScenarios = this.props.ScenarioReducer.scenarios
          .filter(
            (s) =>
              s.conditions &&
              s.conditions.some(
                (c) =>
                  c.isMain &&
                  c.areaId == this.props.areaId &&
                  c.listenerName == "AreaArmListener" &&
                  c.eventName == "OnAreaArmed"
              )
          )
          .map((s) => s.name);
      }

      var sirens = this.getAreaSirens();
      return (
        <View
          style={{
            flex: 1,
            justifyContent: "center",
            direction: getDir(),
          }}
        >
          {this.props.area.areaName != undefined && (
            <Text
              style={{
                textAlign: "center",
                fontSize: 16,
                marginBottom: 8,
                fontWeight: "bold",
                //marginBottom: 15,
              }}
            >
              {this.props.area.areaName}
            </Text>
          )}
          <ScrollView style={style.armOption}>
            {/* shouldCheckDoorWindowsClosed */}
            <AreaArmItem
              value={this.state.shouldCheckDoorWindowsClosed}
              label={translate("area.shouldCheckDoorWindowsClosed")}
              armInProgress={this.state.armInProgress}
              status={
                this.props.area.armReport &&
                this.props.area.armReport.shouldCheckDoorWindowsClosed
              }
              onChange={() =>
                this.setState(
                  {
                    shouldCheckDoorWindowsClosed:
                      !this.state.shouldCheckDoorWindowsClosed,
                  },
                  () => {
                    this.props.ResetArmReport(this.props.areaId);
                  }
                )
              }
              errorMessage={
                Array.isArray(this.props.area.armReport.openWindows) &&
                this.props.area.armReport.openWindows.length > 0
                  ? this.props.area.armReport.openWindows.length == 1
                    ? translate("area.openWindowError", {
                        openWindows:
                          this.props.area.armReport.openWindows.toString(),
                      })
                    : translate("area.openWindowsError", {
                        openWindows:
                          this.props.area.armReport.openWindows.toString(),
                      })
                  : null
              }
            />

            {/* shouldCloseCurtains */}
            {this.props.area.blinds > 0 && (
              <AreaArmItem
                value={this.state.shouldCloseCurtains}
                label={translate("area.shouldCloseCurtains")}
                armInProgress={this.state.armInProgress}
                status={
                  this.props.area.armReport &&
                  this.props.area.armReport.shouldCloseCurtains
                }
                onChange={() =>
                  this.setState({
                    shouldCloseCurtains: !this.state.shouldCloseCurtains,
                  })
                }
              />
            )}
            {/* shouldTurnOffLights */}
            {this.props.area.lights > 0 && (
              <AreaArmItem
                value={this.state.shouldTurnOffLights}
                label={translate("area.shouldTurnOffLights")}
                armInProgress={this.state.armInProgress}
                status={
                  this.props.area.armReport &&
                  this.props.area.armReport.shouldTurnOffLights
                }
                onChange={() =>
                  this.setState({
                    shouldTurnOffLights: !this.state.shouldTurnOffLights,
                  })
                }
              />
            )}
            {/* shouldTurnOffAirConditioners */}
            {this.props.area.hvacs > 0 && (
              <AreaArmItem
                value={this.state.shouldTurnOffAirConditioners}
                label={translate("area.shouldTurnOffAirConditioners")}
                armInProgress={this.state.armInProgress}
                status={
                  this.props.area.armReport &&
                  this.props.area.armReport.shouldTurnOffAirConditioners
                }
                onChange={() =>
                  this.setState({
                    shouldTurnOffAirConditioners:
                      !this.state.shouldTurnOffAirConditioners,
                  })
                }
              />
            )}

            {/* shouldRunScenarios */}
            {definedScenarios.length > 0 && (
              <AreaArmItem
                value={this.state.shouldRunScenarios}
                label={translate("area.shouldRunScenarios")}
                armInProgress={this.state.armInProgress}
                status={
                  this.props.area.armReport &&
                  this.props.area.armReport.shouldRunScenarios
                }
                onChange={() =>
                  this.setState({
                    shouldRunScenarios: !this.state.shouldRunScenarios,
                  })
                }
                message={
                  translate("area.definedScenarios") +
                  ": " +
                  definedScenarios.join(", ")
                }
              />
            )}

            <View
              style={{
                borderBottomColor: Theme.COLORS.MUTED,
                borderBottomWidth: 1,
                marginVertical: 7,
              }}
            ></View>
            <Text
              style={{
                textAlign: Platform.OS == "ios" ? "left" : "auto",
                fontSize: 11,
                marginBottom: 5,
              }}
            >
              {translate("area.notifyOnBreach")}
            </Text>

            <View style={{ marginStart: 20 }}>
              {/* shouldSendNotification */}
              <AreaArmItem
                value={this.state.shouldNotifyBreach}
                label={translate("area.shouldNotifyBreach")}
                armInProgress={false}
                status={undefined}
                onChange={() =>
                  this.setState({
                    shouldNotifyBreach: !this.state.shouldNotifyBreach,
                  })
                }
              />

              {/* shouldSendSMS */}
              <AreaArmItem
                value={this.state.shouldSmsBreach}
                label={translate("area.shouldSmsBreach")}
                armInProgress={false}
                status={undefined}
                onChange={() =>
                  this.setState({
                    shouldSmsBreach: !this.state.shouldSmsBreach,
                  })
                }
              />
            </View>
            {/* shouldTurnOnSirens */}
            {sirens.length > 0 && (
              <AreaArmItem
                value={this.state.shouldTurnOnSirens}
                label={translate("area.shouldTurnOnSirens")}
                armInProgress={false}
                onActiveToggleStyle={Theme.COLORS.ERROR}
                status={undefined}
                onChange={() =>
                  this.setState({
                    shouldTurnOnSirens: !this.state.shouldTurnOnSirens,
                  })
                }
              />
            )}
            {/* === time sirens === */}
            {sirens.length > 0 && this.state.shouldTurnOnSirens && (
              <View>
                <Select
                  label={translate("area.sirensDuration", {
                    sirensDuration: this.state.sirensDuration,
                  })}
                  data={SIRENS_DURATION.map(({ label, value }) => {
                    return {
                      label,
                      value,
                    };
                  })}
                  value={this.state.sirensDuration || 5}
                  onChangeText={(value, index, data) => {
                    this.setState({ sirensDuration: Number(value) });
                  }}
                />
              </View>
            )}
          </ScrollView>
          {/*  === close and submit button ===   */}
          <HStack alignItems="center" space="2">
            <ArButton
              isLoading={
                (this.props.area.armReport &&
                  this.props.area.armReport.inProgress) ||
                !this.props.area.isArmed
                  ? this.state.armInProgress
                  : this.state.disArmInProgress
              }
              onPress={() => {
                let {
                  shouldTurnOffLights,
                  shouldTurnOffAirConditioners,
                  shouldCheckDoorWindowsClosed,
                  shouldCloseCurtains,
                  shouldRunScenarios,
                  shouldNotifyBreach,
                  shouldTurnOnSirens,
                  shouldSmsBreach,
                  sirensDuration,
                } = this.state;
                let { areaId, areaUId } = this.props;
                this.setState({ armInProgress: true });
                this.props.Arm(
                  areaId,
                  areaUId,
                  this.state.accessToken,
                  shouldTurnOffLights,
                  shouldTurnOffAirConditioners,
                  shouldCheckDoorWindowsClosed,
                  shouldCloseCurtains,
                  shouldNotifyBreach,
                  shouldSmsBreach,
                  shouldRunScenarios,
                  shouldTurnOnSirens,
                  sirensDuration
                );
              }}
              style={{
                ...style.modalBtn,
              }}
            >
              {translate("app.confirm")}
            </ArButton>
            {!this.state.armInProgress && (
              <ArButton
                color="muted"
                variant="outline"
                onPress={() => {
                  this.hideArmModal();
                }}
                style={{
                  ...style.modalBtn,
                  marginBottom: 0,
                }}
              >
                {translate("app.close")}
              </ArButton>
            )}
          </HStack>
        </View>
      );
    } else {
      var areaLocks = this.getAreaLocks();
      return (
        <View style={{ flex: 1 }}>
          <View style={{ flex: 1, marginBottom: 20 }}>
            {this.props.area.areaName != undefined && (
              <Text
                style={{
                  textAlign: "center",
                  fontSize: 18,
                  marginTop: 5,
                  marginBottom: 15,
                  fontWeight: "bold",
                }}
              >
                {this.props.area.areaName}
              </Text>
            )}
            <Text style={{ textAlign: "center", fontSize: 12 }}>
              {translate("area.doYouConfirmDisarmArea")}
            </Text>
            {this.props.area.armReport && this.props.area.armReport.error && (
              <Text style={{ color: "#F00", textAlign: "center" }}>
                {translate(`area.${this.props.area.armReport.error}`)}
              </Text>
            )}
          </View>
          <View>
            {areaLocks.length > 0 && (
              <View style={style.armOption}>
                {/* unlockDoorAfterDisarm */}
                {areaLocks.length > 0 && (
                  <AreaArmItem
                    value={this.state.shouldUnlockAfterDisArm}
                    label={translate("area.shouldUnlockAfterDisArm")}
                    armInProgress={false}
                    status={
                      this.props.area.armReport &&
                      this.props.area.armReport.shouldCheckDoorWindowsClosed
                    }
                    onChange={() => {
                      if (this.state.devicesToUnlockAfterDisArm.length == 0) {
                        var devicesToUnlockAfterDisArm =
                          this.getAreaLocks().map((l) => l.deviceId);
                        this.setState({
                          shouldUnlockAfterDisArm:
                            !this.state.shouldUnlockAfterDisArm,
                          devicesToUnlockAfterDisArm,
                        });
                      } else {
                        this.setState({
                          shouldUnlockAfterDisArm:
                            !this.state.shouldUnlockAfterDisArm,
                        });
                      }
                    }}
                  />
                )}
                {this.state.shouldUnlockAfterDisArm && areaLocks.length > 1 && (
                  <View style={{ margin: 10 }}>
                    {areaLocks.map((l, i) => (
                      <AreaArmItem
                        key={i}
                        value={
                          this.state.devicesToUnlockAfterDisArm.indexOf(
                            l.deviceId
                          ) >= 0
                        }
                        label={l.deviceName}
                        armInProgress={false}
                        status={true}
                        onChange={() => {
                          let devicesToUnlockAfterDisArm = [
                            ...this.state.devicesToUnlockAfterDisArm,
                          ];
                          let { shouldUnlockAfterDisArm } = this.state;

                          if (
                            devicesToUnlockAfterDisArm.indexOf(l.deviceId) >= 0
                          ) {
                            devicesToUnlockAfterDisArm.splice(
                              devicesToUnlockAfterDisArm.indexOf(l.deviceId),
                              1
                            );
                            if (devicesToUnlockAfterDisArm.length == 0) {
                              shouldUnlockAfterDisArm = false;
                            }
                          } else {
                            devicesToUnlockAfterDisArm.push(l.deviceId);
                          }
                          this.setState({
                            devicesToUnlockAfterDisArm,
                            shouldUnlockAfterDisArm,
                          });
                        }}
                      />
                    ))}
                  </View>
                )}
              </View>
            )}
            <HStack alignItems="center" space="2">
              <ArButton
                isLoading={
                  (this.props.area.armReport &&
                    this.props.area.armReport.inProgress) ||
                  !this.props.area.isArmed
                    ? this.state.armInProgress
                    : this.state.disArmInProgress
                }
                onPress={() => {
                  this.setState({ disArmInProgress: true });
                  this.props.Disarm(
                    this.props.areaId,
                    this.props.areaUId,
                    this.state.accessToken,
                    this.state.shouldUnlockAfterDisArm,
                    this.state.devicesToUnlockAfterDisArm
                  );
                  setTimeout(() => {
                    if (!this.props.area.armReport.error) {
                      this.setState({ disArmInProgress: false });
                      this.hideArmModal();
                    }
                  }, 1500);
                }}
                style={{
                  ...style.modalBtn,
                }}
              >
                {translate("app.confirm")}
              </ArButton>
              {!this.state.armInProgress && (
                <ArButton
                  color="muted"
                  variant="outline"
                  onPress={() => {
                    this.hideArmModal();
                  }}
                  style={{
                    ...style.modalBtn,
                    marginBottom: 0,
                  }}
                >
                  {translate("app.close")}
                </ArButton>
              )}
            </HStack>
          </View>
        </View>
      );
    }
  };

  turnOnLights = () => {
    (this.props.areaId || this.props.areaUId) &&
      this.props.turnOnAllLights(
        this.props.areaId,
        this.props.areaUId,
        this.state.accessToken
      );
  };
  turnOffLights = () => {
    (this.props.areaId || this.props.areaUId) &&
      this.props.turnOffAllLights(
        this.props.areaId,
        this.props.areaUId,
        this.state.accessToken
      );
  };
  turnOnOutlets = () => {
    (this.props.areaId || this.props.areaUId) &&
      this.props.turnOnAllOutlets(
        this.props.areaId,
        this.props.areaUId,
        this.state.accessToken
      );
  };
  turnOffOutlets = () => {
    (this.props.areaId || this.props.areaUId) &&
      this.props.turnOffAllOutlets(
        this.props.areaId,
        this.props.areaUId,
        this.state.accessToken
      );
  };
  turnOnSirens = () => {
    typeof this.props.onTurnOnAllSirens == "function" &&
      this.props.onTurnOnAllSirens();
  };
  turnOffSirens = () => {
    (this.props.areaId || this.props.areaUId) &&
      this.props.turnOffAllSirens(
        this.props.areaId,
        this.props.areaUId,
        this.state.accessToken
      );
  };
  turnOnSwitches = () => {
    (this.props.areaId || this.props.areaUId) &&
      this.props.turnOnAllSwitches(
        this.props.areaId,
        this.props.areaUId,
        this.state.accessToken
      );
  };
  turnOffSwitches = () => {
    (this.props.areaId || this.props.areaUId) &&
      this.props.turnOffAllSwitches(
        this.props.areaId,
        this.props.areaUId,
        this.state.accessToken
      );
  };
  turnOnWateringSwitches = () => {
    (this.props.areaId || this.props.areaUId) &&
      this.props.turnOnAllWateringSwitches(
        this.props.areaId,
        this.props.areaUId,
        this.state.accessToken
      );
  };
  turnOffWateringSwitches = () => {
    (this.props.areaId || this.props.areaUId) &&
      this.props.turnOffAllWateringSwitches(
        this.props.areaId,
        this.props.areaUId,
        this.state.accessToken
      );
  };

  openBlinds = () => {
    (this.props.areaId || this.props.areaUId) &&
      this.props.openAllCurtains(
        this.props.areaId,
        this.props.areaUId,
        this.state.accessToken
      );
  };
  closeBlinds = () => {
    (this.props.areaId || this.props.areaUId) &&
      this.props.closeAllCurtains(
        this.props.areaId,
        this.props.areaUId,
        this.state.accessToken
      );
  };

  turnOnHVACs = () => {
    (this.props.areaId || this.props.areaUId) &&
      this.props.turnOnAllHVAC(
        this.props.areaId,
        this.props.areaUId,
        this.state.accessToken
      );
  };
  turnOffHVACs = () => {
    (this.props.areaId || this.props.areaUId) &&
      this.props.turnOffAllHVAC(
        this.props.areaId,
        this.props.areaUId,
        this.state.accessToken
      );
  };

  hideArmModal = () => {
    this.setState({
      showArmModal: false,
      armInProgress: false,
    });
    this.props.ResetArmReport(this.props.areaId);

    if (this.props.area.armReport && this.props.area.armReport.inProgress) {
    }
  };
  loadArmModal = () => {
    var devicesToUnlockAfterDisArm = this.getAreaLocks().map((d) => d.deviceId);
    this.setState({
      showArmModal: true,
      armCountDownStarted: false,
      devicesToUnlockAfterDisArm,
    });
  };

  getDevicesByType(deviceType = "") {
    var selectedDevices = [];
    var areaDevices = AreaHelper.findAreaById(
      this.props.AreaReducer.areas,
      this.props.areaId
    ).devices;
    for (var i in this.props.DeviceReducer.list) {
      var d = this.props.DeviceReducer.list[i];
      if (areaDevices.indexOf(d.deviceId) >= 0 && d.deviceType == deviceType) {
        selectedDevices.push(d);
      }
    }

    return selectedDevices;
  }
  getAllDevicesByDeviceType(deviceType = "") {
    var selectedDevices = [];
    for (var i in this.props.DeviceReducer.list) {
      var d = this.props.DeviceReducer.list[i];
      if (d.deviceType == deviceType) {
        selectedDevices.push(d);
      }
    }

    return selectedDevices;
  }

  getAreaLocks = () => {
    if (this.props.area.locks >= 1) {
      return this.getDevicesByType(DeviceTypes.DOORLOCK);
    }
    return [];
  };

  getAreaSirens = () => {
    if (this.props.area.sirens > 0) {
      return this.getDevicesByType(DeviceTypes.SIREN);
    }
    return [];
  };
  getAreaStateIcon = () => {
    if (this.props.area.userDefinedStates.length > 0) {
      for (var i in this.props.area.userDefinedStates) {
        if (this.props.area.userDefinedStates[i].isActivated) {
          return this.props.area.userDefinedStates[i];
        }
      }
    }
    return null;
  };
  // === isKioskMode ===
  setActiveDevice = (changeArea = false) => {
    let activeDeviceType = null;
    var powerMetersCount = 0;
    if (this.props.area.relatedAreaPowerMeterId) {
      powerMetersCount++;
    }
    if (this.props.area.relatedAreaWaterMeterId) {
      powerMetersCount++;
    }

    const areaListBathroom = useAreaListByAreaType(
      this.props.AreaReducer.areas,
      this.props.areaId,
      AreaTypes.BATHROOM
    );
    const bathroomCount = (areaListBathroom && areaListBathroom.length) || 0;

    if (this.props.area.lights) activeDeviceType = DeviceTypes.LIGHT;
    else if (this.props.area.accessControls)
      activeDeviceType = DeviceTypes.ACCESS_CONTROL;
    else if (this.props.area.sensors) activeDeviceType = DeviceTypes.SENSOR;
    else if (this.props.area.blinds) activeDeviceType = DeviceTypes.CURTAIN;
    else if (this.props.area.hvacs)
      activeDeviceType = DeviceTypes.AIR_CONDITIONER;
    else if (this.props.area.cameras) activeDeviceType = DeviceTypes.CAMERA;
    else if (this.props.area.smartSpeakers)
      activeDeviceType = DeviceTypes.SMART_SPEAKER;
    else if (this.props.area.cameraDoorlocks && Platform.OS === "android")
      activeDeviceType = DeviceTypes.DOORBELL;
    else if (this.props.area.switches)
      activeDeviceType = DeviceTypes.POWER_SWITCH;
    else if (this.props.area.elevators) activeDeviceType = DeviceTypes.ELEVATOR;
    else if (this.props.area.wateringSwitches)
      activeDeviceType = DeviceTypes.WATERING_SWITCH;
    else if (this.props.area.outlets) activeDeviceType = DeviceTypes.OUTLET;
    else if (this.props.area.locks) activeDeviceType = DeviceTypes.DOORLOCK;
    else if (this.props.area.sirens) activeDeviceType = DeviceTypes.SIREN;
    else if (powerMetersCount) activeDeviceType = DeviceTypes.POWER_METER;
    else if (bathroomCount) activeDeviceType = AreaTypes.BATHROOM;
    if (activeDeviceType !== this.state.activeDeviceType) {
      this.handleOnItemCounterPress(
        this.state.activeDeviceType || activeDeviceType
      );
    }
  };
  renderHeaderArea = () => {
    return (
      <HStack alignItems="center" justifyContent="space-between" mt="1" mb="3">
        <VStack space="1">
          <Text style={{ fontSize: 20 }}>{this.props.area.areaName}</Text>
          {(this.props.area.isArmed || this.props.area.isBreached) && (
            <Text
              style={{
                fontSize: 10,
                color: this.props.area.isBreached
                  ? Theme.COLORS.ERROR
                  : Theme.COLORS.ORANGE,
              }}
            >
              (
              {this.props.area.isBreached
                ? translate("area.isBreached")
                : this.props.area.isArmed && translate("area.isArm")}
              )
            </Text>
          )}
        </VStack>

        <HStack space="2">
          {/* Access Control Open All Doors */}
          {this.state.activeDeviceType == DeviceTypes.ACCESS_CONTROL && (
            <IconButton
              onPress={() => {
                this.areaModel.accessLevelValue &&
                  this.areaModel.accessLevelValue > 100 &&
                  this.handleOnAccessControlOpenAllAreaDoors();
              }}
              icon={{
                code: faCharCodes.faDoorOpen, //"\uf8b8", // flashlight
                style: {
                  fontFamily: "FontAwesomeProLight",
                  fontSize: 30,
                  color: Theme.COLORS.ORANGE,
                  padding: 5,
                  height: 30,
                  //transform: [{ rotate: "-90deg" }],
                },
              }}
            />
          )}
          {/* lightMeter */}
          <LightMeter
            areaId={this.props.areaId}
            areaUId={this.props.areaUId}
            style={style.titleSensor}
          />
          {/* thermometer */}
          <Thermometer
            areaId={this.props.areaId}
            areaUId={this.props.areaUId}
            style={style.titleSensorThermometer}
          />
        </HStack>
      </HStack>
    );
  };

  hasOneDeviceType(...areas) {
    return areas.filter((v) => v).length == 1;
  }

  render() {
    let Lights = null;
    if (this.props.area.lights) {
      Lights = (
        <AreaItem
          isKioskMode={this.props.isKioskMode}
          activeItem={this.state.activeDeviceType === DeviceTypes.LIGHT}
          mainIcon={faCharCodes.faLightbulbOn} //ue016
          mainIconColor={Theme.COLORS.DEVICE_TYPES.LIGHT} // "#ffcc00" // ccc
          mainIconRotate={"180deg"}
          caption={translate("v2Dashboard.Lights")}
          count={this.props.area.lights}
          subAction1_Caption={translate("area.allOn")}
          subAction1={this.turnOnLights}
          subAction2_Caption={translate("area.allOff")}
          subAction2={this.turnOffLights}
          onCounterPress={() =>
            this.handleOnItemCounterPress(DeviceTypes.LIGHT)
          }
          // subIconStyle={{ top: -5 }}
        />
      );
    }

    let Blinds = null;
    if (this.props.area.blinds) {
      Blinds = (
        <AreaItem
          isKioskMode={this.props.isKioskMode}
          activeItem={this.state.activeDeviceType === DeviceTypes.CURTAIN}
          mainIcon={getIconByDeviceType(DeviceTypes.CURTAIN)} //"\uf8fb"
          mainIconColor={Theme.COLORS.DEVICE_TYPES.CURTAIN} //"#6699cc"
          // mainIconColor2="#cccccc"
          caption={translate("v2Dashboard.Blinds")}
          count={this.props.area.blinds}
          // mainAction={navigateTo(view = Light, Area = this.props.area.lights)}
          subAction1_Caption={translate("area.allDown")}
          subAction1_Font={"FontAwesomeProLight"}
          subAction1={this.closeBlinds}
          subAction2_Caption={translate("area.allUp")}
          subAction2_Font={"FontAwesomeProLight"}
          subAction2={this.openBlinds}
          onCounterPress={() =>
            this.handleOnItemCounterPress(DeviceTypes.CURTAIN)
          }
          subIconStyle={{ top: -5 }}
        />
      );
    }

    let HVACs = null;
    if (this.props.area.hvacs) {
      HVACs = (
        <AreaItem
          isKioskMode={this.props.isKioskMode}
          activeItem={
            this.state.activeDeviceType === DeviceTypes.AIR_CONDITIONER
          }
          mainIcon={getIconByDeviceType(DeviceTypes.AIR_CONDITIONER)} //"\uf8f4"
          mainIconColor={Theme.COLORS.DEVICE_TYPES.AIR_CONDITIONER} //"#99cc99"
          // mainIconColor2="#cccccc"
          caption={translate("v2Dashboard.HVAC")}
          count={this.props.area.hvacs}
          // mainAction={navigateTo(view = Light, Area = this.props.area.lights)}
          //subAction1_Icon={faCharCodes.faToggleOn}
          subAction1_Caption={translate("area.allOn")}
          subAction1={this.turnOnHVACs}
          //subAction2_Icon={faCharCodes.faToggleOff}
          subAction2_Caption={translate("area.allOff")}
          subAction2={this.turnOffHVACs}
          onCounterPress={() =>
            this.handleOnItemCounterPress(DeviceTypes.AIR_CONDITIONER)
          }
          subIconStyle={{ top: -5 }}
        />
      );
    }

    let Cameras = null;
    if (this.props.area.cameras && IS_MOBILE) {
      Cameras = (
        <AreaItem
          isKioskMode={this.props.isKioskMode}
          activeItem={this.state.activeDeviceType === DeviceTypes.CAMERA}
          mainIcon={getIconByDeviceType(DeviceTypes.CAMERA)} //"\uf8ac"
          mainIconColor={Theme.COLORS.DEVICE_TYPES.CAMERA} //"#cc9966"
          //mainIconColor2="#cccccc"
          caption={translate("v2Dashboard.Camera")}
          count={this.props.area.cameras}
          onCounterPress={() =>
            this.handleOnItemCounterPress(DeviceTypes.CAMERA)
          }
          // mainAction={navigateTo(view = Light, Area = this.props.area.lights)}
        />
      );
    }

    let selectedCamera = null;
    if (this.state.selectedCameraId && IS_MOBILE) {
      let videoWidth = this.props.isKioskMode
          ? WINDOW_WIDTH * 0.45
          : SCREEN_WIDTH * 0.9,
        videoHeight = this.props.isKioskMode
          ? WINDOW_WIDTH * ((9 * 0.45) / 16)
          : SCREEN_WIDTH * ((9 * 0.9) / 16),
        closeIconSize = 28;

      selectedCamera = (
        <View
          style={{
            backgroundColor: "#000",
            width: videoWidth,
            height: videoHeight,
            overflow: "hidden",
            alignSelf: "center",
            marginBottom: 20,
            borderRadius: 5,
          }}
        >
          <RTSPPlayer
            cameraId={this.state.selectedCameraId}
            width={videoWidth}
            height={videoHeight}
            spinnerSize={24}
            maxRepeatOnFailure={2}
            onError={(e) => {
              try {
                var httpClient = axios.create();
                var errorMessage = "error on RTSPLayer.native\r\n";
                if (e) {
                  if (typeof e === "string") errorMessage += e;
                  else errorMessage += JSON.stringify(e);
                }
                AppLog(
                  httpClient,
                  this.props.AppReducer.serverUrl,
                  errorMessage,
                  "ERROR",
                  0
                );
              } catch (_e) {
                console.log("error on sendig rtsplayer log", _e);
              }
            }}
          />
          <TouchableOpacity
            style={{
              backgroundColor: "#ffffff50",
              width: closeIconSize,
              height: closeIconSize,
              borderRadius: closeIconSize / 2,
              position: "absolute",
              start: 10,
              top: 10,
              alignItems: "center",
              justifyContent: "center",
            }}
            onPress={this.handleSelectedCameraClose}
          >
            <FontAwesomeIcon icon={faTimes} size={closeIconSize - 4} />
          </TouchableOpacity>
        </View>
      );
    }

    let SmartSpeakers = null;
    if (this.props.area.smartSpeakers) {
      SmartSpeakers = (
        <AreaItem
          isKioskMode={this.props.isKioskMode}
          activeItem={this.state.activeDeviceType === DeviceTypes.SMART_SPEAKER}
          mainIcon={getIconByDeviceType(DeviceTypes.SMART_SPEAKER)} //"\uf8b2"
          mainIconColor={Theme.COLORS.DEVICE_TYPES.SMART_SPEAKER}
          // mainIconColor2="#cccccc"
          caption={translate("v2Dashboard.SmartSpeaker")}
          count={this.props.area.smartSpeakers}
          // mainAction={navigateTo(view = Light, Area = this.props.area.lights)}
          // TODO
          // subAction1_Icon={faCharCodes.faPlayCircle} //"\uf144"
          // subAction1_Caption={translate("v2Dashboard.MultimediaPlay")}
          // subAction2_Icon={faCharCodes.faPauseCircle} //"\uf28b"
          // subAction2_Caption={translate("v2Dashboard.MultimediaPause")}

          // subAction1={allLightsOn(Area = this.props.area.lights)}
          subAction1_Font="FontAwesomeProRegular"
          subAction2_Font="FontAwesomeProRegular"
          onCounterPress={() =>
            this.handleOnItemCounterPress(DeviceTypes.SMART_SPEAKER)
          }
          style={{ justifyContent: "center", alignItems: "flex-start" }}
          // subAction2={allLightsOff(Area = this.props.area.lights)}
          subIconStyle={{ top: -5 }}
        />
      );
    }

    // let sampleSpeaker = {
    //   mediaRendererState: CONSTANTS.MULTI_MEDIA_STATE.stopped,
    //   deviceId: 323,
    //   deviceName: "test speaker",
    //   isMuted: false,
    //   currentPlayListId: 17,
    //   currentPlayListTitle: "some playlist",
    //   currentPlayingTrackId: "seu0s9f8sd09f8sd0f98sd0",
    //   currentPlayingTrackTitle:
    //     "some track with very long long long name which will not fit in phones screen",
    //   currentPlayingTrackDuration: 206000,
    //   volume: 40,
    // };
    let playingSpeakerDevice = this.getDevicesByType(DeviceTypes.SMART_SPEAKER);
    var playingSpeaker = playingSpeakerDevice.find(
      (d) => d.mediaRendererState == CONSTANTS.MULTI_MEDIA_STATE.playing
    );

    if (!playingSpeaker) {
      playingSpeaker = playingSpeakerDevice.find(
        (d) => d.mediaRendererState == CONSTANTS.MULTI_MEDIA_STATE.paused
      );
    }
    let SelectedSpeaker = null;
    if (playingSpeaker) {
      var sampleSpeaker = playingSpeaker;
      var _volume = sampleSpeaker.volume;
      if (sampleSpeaker.slavesList && sampleSpeaker.slavesList.length > 0) {
        var slaves = this.getAllDevicesByDeviceType(DeviceTypes.SMART_SPEAKER)
          .filter((s) => sampleSpeaker.slavesList.includes(s.deviceUId))
          .map((s) => s.volume);
        slaves.push(sampleSpeaker.volume);
        _volume = Math.floor(slaves.reduce((a, b) => a + b, 0) / slaves.length);
      }
      SelectedSpeaker = (
        <MediaPlayer
          isKioskMode={this.props.isKioskMode}
          areaId={this.props.areaId}
          areaUId={this.props.areaUId}
          buildingId={this.props.AppReducer.currentBuilding.buildingId}
          accessToken={this.props.AppReducer.currentServer.accessToken}
          serverUrl={this.props.AppReducer.serverUrl}
          playingState={sampleSpeaker.mediaRendererState}
          style={style.mediaPlayerContainer}
          smartSpeakerDeviceId={sampleSpeaker.deviceId}
          smartSpeakerDeviceUId={sampleSpeaker.deviceUId}
          smartSpeakerDeviceName={sampleSpeaker.deviceName}
          isMuted={sampleSpeaker.isMuted}
          playListId={sampleSpeaker.currentPlayListId}
          playListUId={sampleSpeaker.currentPlayListUId}
          playListName={sampleSpeaker.currentPlayListTitle}
          trackId={sampleSpeaker.currentPlayingTrackId}
          trackName={sampleSpeaker.currentPlayingTrackTitle}
          trackDuration={sampleSpeaker.currentPlayingTrackDuration}
          currentTime={sampleSpeaker.currentPlayingTrackTime}
          volume={_volume}
          input={sampleSpeaker.input}
          slavesList={sampleSpeaker.slavesList}
          allSpeakers={this.getAllDevicesByDeviceType(
            DeviceTypes.SMART_SPEAKER
          )}
          onInit={() => {
            this.props.GetSpeakerState(
              this.props.areaId,
              this.props.areaUId,
              sampleSpeaker.deviceId,
              sampleSpeaker.deviceUId,
              this.state.accessToken
            );
          }}
          onResetCurrentTimePosition={() => {
            this.props.ResetSpeakerSeekBar(
              sampleSpeaker.deviceId,
              sampleSpeaker.deviceUId
            );
          }}
          onClose={() => {
            this.props.StopSpeaker(
              this.props.areaId,
              this.props.areaUId,
              sampleSpeaker.deviceId,
              sampleSpeaker.deviceUId,
              this.state.accessToken
            );
            this.handleSelectedSmartSpeakerClose();
          }}
          onNext={() =>
            this.props.NextSpeakerTrack(
              this.props.areaId,
              this.props.areaUId,
              sampleSpeaker.deviceId,
              sampleSpeaker.deviceUId,
              this.state.accessToken
            )
          }
          onPause={() => {
            this.props.PauseSpeaker(
              this.props.areaId,
              this.props.areaUId,
              sampleSpeaker.deviceId,
              sampleSpeaker.deviceUId,
              this.state.accessToken
            );
          }}
          onPlay={() => {
            // console.log("this.state.accessToken", this.state.accessToken);
            // console.log("sampleSpeaker", sampleSpeaker);
            this.props.PlaySpeaker(
              this.props.areaId,
              this.props.areaUId,
              sampleSpeaker.deviceId,
              sampleSpeaker.deviceUId,
              sampleSpeaker.currentPlayListId,
              sampleSpeaker.currentPlayListUId,
              sampleSpeaker.currentPlayingTrackId,
              this.state.accessToken
            );
          }}
          onResume={() =>
            this.props.ResumeSpeaker(
              this.props.areaId,
              this.props.areaUId,
              sampleSpeaker.deviceId,
              sampleSpeaker.deviceUId,
              sampleSpeaker.currentPlayListId,
              sampleSpeaker.currentPlayListUId,
              sampleSpeaker.currentPlayingTrackId,
              this.state.accessToken
            )
          }
          onPrevious={() =>
            this.props.PreviousSpeakerTrack(
              this.props.areaId,
              this.props.areaUId,
              sampleSpeaker.deviceId,
              sampleSpeaker.deviceUId,
              this.state.accessToken
            )
          }
          onSeek={(position) =>
            this.props.SeekSpeaker(
              this.props.areaId,
              this.props.areaUId,
              sampleSpeaker.deviceId,
              sampleSpeaker.deviceUId,
              position,
              this.state.accessToken
            )
          }
          onVolumeChange={(volume, deviceId, deviceUId, group = false) =>
            this.props.ChangeSpeakerVolume(
              this.props.areaId,
              this.props.areaUId,
              deviceId,
              deviceUId,
              volume,
              group,
              this.state.accessToken
            )
          }
          onToggleMute={(muted, group) =>
            this.props.ToggleSpeakerMute(
              this.props.areaId,
              this.props.areaUId,
              sampleSpeaker.deviceId,
              sampleSpeaker.deviceUId,
              muted,
              group,
              this.state.accessToken
            )
          }
          onToggleSlaveMute={(speakerDeviceUId, speakerDeviceId, muted) => {
            this.props.ToggleSpeakerMute(
              this.props.areaId,
              this.props.areaUId,
              speakerDeviceId,
              speakerDeviceUId,
              muted,
              false,
              this.state.accessToken
            );
          }}
          onInputChange={(input) => {
            this.props.SetSmartSpeakerInput(
              this.props.areaId,
              this.props.areaUId,
              sampleSpeaker.deviceId,
              sampleSpeaker.deviceUId,
              input,
              this.state.accessToken
            );
          }}
          onList={() => {
            this.handleOnMediaPlayerPlayListPress(
              sampleSpeaker.deviceId,
              sampleSpeaker.deviceUId,
              sampleSpeaker.currentPlayListId,
              sampleSpeaker.currentPlayListUId
            );
          }}
          onUpdateSlaveSmartSpeakerLocal={(
            masterDeviceUId,
            slaveDeviceUId,
            status = "ADD"
          ) => {
            this.props.updateSlaveSmartSpeaker(
              masterDeviceUId,
              slaveDeviceUId,
              status
            );
          }}
        />
      );
    }

    let cameraDoorlocks = null;
    if (this.props.area.cameraDoorlocks && Platform.OS === "android") {
      cameraDoorlocks = (
        <AreaItem
          isKioskMode={this.props.isKioskMode}
          activeItem={this.state.activeDeviceType === DeviceTypes.DOORBELL}
          mainIcon={getIconByDeviceType(DeviceTypes.DOORBELL)} //"\uf832"
          mainIconColor={Theme.COLORS.DEVICE_TYPES.DOORBELL} //"#449977" // ccc
          //mainIconColor2="#ccffcc"
          caption={translate("v2Dashboard.Doorbell")}
          captionFontSize="14"
          count={this.props.area.cameraDoorlocks}
          onCounterPress={() =>
            this.handleOnItemCounterPress(DeviceTypes.DOORBELL)
          }
          subIconStyle={{ top: -5 }}
        />
      );
    }

    let Switches = null;
    if (this.props.area.switches) {
      Switches = (
        <AreaItem
          isKioskMode={this.props.isKioskMode}
          activeItem={this.state.activeDeviceType === DeviceTypes.POWER_SWITCH}
          mainIcon={getIconByDeviceType(DeviceTypes.POWER_SWITCH)} // "\ue019"
          mainIconColor={Theme.COLORS.DEVICE_TYPES.POWER_SWITCH} //"#00ff99" // ccc
          //mainIconColor2="#00ff99"
          caption={translate("v2Dashboard.Switches")}
          count={this.props.area.switches}
          //subAction1_Icon={faCharCodes.faToggleOn}
          subAction1_Caption={translate("area.allOn")}
          subAction1={this.turnOnSwitches}
          //subAction2_Icon={faCharCodes.faToggleOff}
          subAction2_Caption={translate("area.allOff")}
          subAction2={this.turnOffSwitches}
          onCounterPress={() =>
            this.handleOnItemCounterPress(DeviceTypes.POWER_SWITCH)
          }
          subIconStyle={{ top: -5 }}
        />
      );
    }

    let Elevators = null;
    if (this.props.area.elevators) {
      Elevators = (
        <AreaItem
          isKioskMode={this.props.isKioskMode}
          activeItem={this.state.activeDeviceType === DeviceTypes.ELEVATOR}
          mainIcon={getIconByDeviceType(DeviceTypes.ELEVATOR)} //"\ue030"
          mainIconColor={Theme.COLORS.DEVICE_TYPES.ELEVATOR} //"#2F21E0"
          mainIconColor2="blue"
          caption={translate("v2Dashboard.Elevator")}
          count={this.props.area.elevators}
          onCounterPress={() =>
            this.handleOnItemCounterPress(DeviceTypes.ELEVATOR)
          }
          subIconStyle={{ top: -5 }}
        />
      );
    }
    let WateringSwitches = null;
    if (this.props.area.wateringSwitches) {
      WateringSwitches = (
        <AreaItem
          isKioskMode={this.props.isKioskMode}
          activeItem={
            this.state.activeDeviceType === DeviceTypes.WATERING_SWITCH
          }
          mainIcon={getIconByDeviceType(DeviceTypes.WATERING_SWITCH)}
          mainIconColor={Theme.COLORS.DEVICE_TYPES.WATERING_SWITCH} //"#6699ff"
          caption={translate("v2Dashboard.WateringSwitch")}
          count={this.props.area.wateringSwitches}
          //subAction1_Icon={faCharCodes.faToggleOn}
          subAction1_Caption={translate("area.allOn")}
          subAction1={this.turnOnWateringSwitches}
          //subAction2_Icon={faCharCodes.faToggleOff}
          subAction2_Caption={translate("area.allOff")}
          subAction2={this.turnOffWateringSwitches}
          onCounterPress={() =>
            this.handleOnItemCounterPress(DeviceTypes.WATERING_SWITCH)
          }
          subIconStyle={{ top: -5 }}
        />
      );
    }

    let Outlets = null;
    if (this.props.area.outlets) {
      Outlets = (
        <AreaItem
          isKioskMode={this.props.isKioskMode}
          activeItem={this.state.activeDeviceType === DeviceTypes.OUTLET}
          mainIcon={getIconByDeviceType(DeviceTypes.OUTLET)} // "\ue01c"
          mainIconColor={Theme.COLORS.DEVICE_TYPES.OUTLET} //"#9933ff" //ccc
          caption={translate("v2Dashboard.Outlets")}
          count={this.props.area.outlets}
          //subAction1_Icon={faCharCodes.faToggleOn}
          subAction1_Caption={translate("area.allOn")}
          subAction1={this.turnOnOutlets}
          subAction2={this.turnOffOutlets}
          //subAction2_Icon={faCharCodes.faToggleOff}
          subAction2_Caption={translate("area.allOff")}
          onCounterPress={() =>
            this.handleOnItemCounterPress(DeviceTypes.OUTLET)
          }
          subIconStyle={{ top: -5 }}
        />
      );
    }

    let Locks = null;
    if (this.props.area.locks) {
      Locks = (
        <AreaItem
          isKioskMode={this.props.isKioskMode}
          activeItem={this.state.activeDeviceType === DeviceTypes.DOORLOCK}
          mainIcon={getIconByDeviceType(DeviceTypes.DOORLOCK)} //"\uf084"
          mainIconColor={Theme.COLORS.DEVICE_TYPES.DOORLOCK} //"#666699"
          caption={translate("v2Dashboard.Locks")}
          count={this.props.area.locks}
          onCounterPress={() => this.handleOnDoorLockPress()}
          subIconStyle={{ top: -5 }}
        />
      );
    }

    let AccessControls = null;
    if (this.props.area.accessControls) {
      AccessControls = (
        <AreaItem
          isKioskMode={this.props.isKioskMode}
          activeItem={
            this.state.activeDeviceType === DeviceTypes.ACCESS_CONTROL
          }
          mainIcon={getIconByDeviceType(DeviceTypes.ACCESS_CONTROL)} //"\uf084"
          mainIconColor={Theme.COLORS.DEVICE_TYPES.ACCESS_CONTROL} //"#666699"
          caption={translate("v2Dashboard.AccessControls")}
          count={this.props.area.accessControls}
          onCounterPress={() => this.handleOnAccessControlsPress()}
          subIconStyle={{ top: -5 }}
        />
      );
    }

    let Sensors = null;
    if (this.props.area.sensors) {
      Sensors = (
        <AreaItem
          isKioskMode={this.props.isKioskMode}
          activeItem={this.state.activeDeviceType === DeviceTypes.SENSOR}
          mainIcon={getIconByDeviceType(DeviceTypes.SENSOR)}
          mainIconColor={Theme.COLORS.DEVICE_TYPES.SENSOR} //"#ff9999" // ccc
          //mainIconColor2="#ff9999"
          caption={translate("v2Dashboard.Sensors")}
          captionFontSize="14"
          count={this.props.area.sensors}
          onCounterPress={() =>
            this.handleOnItemCounterPress(DeviceTypes.SENSOR)
          }
          // mainAction={navigateTo(view = Light, Area = this.props.area.lights)}
          subIconStyle={{ top: -5 }}
        />
      );
    }

    let powerMeters = null;
    var powerMetersCount = 0;
    if (this.props.area.relatedAreaPowerMeterId) {
      powerMetersCount++;
    }
    if (this.props.area.relatedAreaWaterMeterId) {
      powerMetersCount++;
    }

    if (powerMetersCount > 0) {
      powerMeters = (
        <AreaItem
          isKioskMode={this.props.isKioskMode}
          activeItem={this.state.activeDeviceType === DeviceTypes.POWER_METER}
          mainIcon={getIconByDeviceType(DeviceTypes.POWER_METER)} //"\uf627"
          mainIconColor={Theme.COLORS.DEVICE_TYPES.POWER_METER} //"#b79e4d"
          //mainIconColor2="#FFD43B"
          caption={translate("v2Dashboard.PowerMeters")}
          captionFontSize="14"
          count={powerMetersCount}
          onCounterPress={() =>
            this.handleOnItemCounterPress(DeviceTypes.POWER_METER)
          }
          // mainAction={navigateTo(view = Light, Area = this.props.area.lights)}
          subIconStyle={{ top: -5 }}
        />
      );
    }

    let Sirens = null;
    if (this.props.area.sirens) {
      Sirens = (
        <AreaItem
          isKioskMode={this.props.isKioskMode}
          activeItem={this.state.activeDeviceType === DeviceTypes.SIREN}
          mainIcon={getIconByDeviceType(DeviceTypes.SIREN)} // "\ue01c"
          mainIconColor={Theme.COLORS.DEVICE_TYPES.SIREN} //"#d9004c"
          caption={translate("v2Dashboard.Sirens")}
          count={this.props.area.sirens}
          // subAction1_Icon={faCharCodes.faToggleOn}
          // subAction1={this.turnOnSirens}
          // subAction1_Caption={translate("v2Dashboard.SirensOn")}
          // subAction2={this.turnOffSirens}
          // subAction2_Icon={faCharCodes.faToggleOff}
          // subAction2_Caption={translate("v2Dashboard.SirensOff")}
          onCounterPress={() =>
            this.handleOnItemCounterPress(DeviceTypes.SIREN)
          }
          subIconStyle={{ top: -5 }}
        />
      );
    }

    let Armed = null;
    if (this.props.area.isArmable) {
      let _armedColor1 = "#aaa",
        _armedColor2 = "#ccc",
        _armedIconSize = 20;

      if (this.props.area.isBreached) {
        (_armedColor1 = Theme.COLORS.WHITE),
          (_armedColor2 = Theme.COLORS.ERROR),
          (_armedIconSize = 25);
      } else if (this.props.area.isArmed) {
        (_armedColor1 = Theme.COLORS.WHITE),
          (_armedColor2 = "#ff9900"),
          (_armedIconSize = 25);
      }
      Armed = (
        <IconButton
          onPress={this.loadArmModal}
          style={[
            {
              borderColor: Theme.COLORS.BORDER_COLOR,
              borderLeftWidth: !this.props.showAreaState ? 0 : 1,
              padding: 5,
              borderRadius: 5,
              justifyContent: "center",
              alignItems: "center",

              width: 40,
              height: 40,
            },
            IS_MOBILE && {
              borderRightWidth: !this.props.showAreaState ? 0 : 1,
            },
          ]}
          icon={{
            code: this.props.area.isBreached
              ? faCharCodes.faExclamationTriangle
              : this.props.area.isArmed
              ? faCharCodes.faShieldCheck
              : faCharCodes.faShield,
            style: {
              color: _armedColor1,
              fontFamily: faCharCodes.FONT_FAMILIES.PRO_REGULAR,
              fontSize: _armedIconSize,
              transform: [{ rotate: "0deg" }],
            },
          }}
        />
      );
    }
    let AreaState = null;
    let userState = this.getAreaStateIcon();
    let areaStateIcon = userState?.activeIcon;
    let areaStateText = userState?.name || null;
    if (this.getAreaStateIcon() != null) {
      let _areaStateColor1 = "#ff8400",
        _areaStateIconSize = 25;
      AreaState = (
        <IconButton
          onPress={() => {
            typeof this.props.OnPressAreaStateIcon === "function" &&
              this.props.OnPressAreaStateIcon(userState);
          }}
          style={[
            {
              borderColor: Theme.COLORS.BORDER_COLOR,
              borderEndWidth: areaStateIcon != null ? 0 : 1,
              padding: 3,
            },
            IS_MOBILE
              ? { borderStartWidth: areaStateIcon != null ? 0 : 1 }
              : { borderEndWidth: areaStateIcon != null ? 0 : 1 },
          ]}
          icon={{
            code: areaStateIcon,
            style: {
              color: _areaStateColor1,
              fontFamily: faCharCodes.FONT_FAMILIES.PRO_REGULAR,
              fontSize: _areaStateIconSize,
              transform: [{ rotate: "0deg" }],
            },
          }}
        />
      );
    }

    // === Bathroom ===
    const areaListBathroom = useAreaListByAreaType(
      this.props.AreaReducer.areas,
      this.props.areaId,
      AreaTypes.BATHROOM
    );
    const bathroomCount = (areaListBathroom && areaListBathroom.length) || 0;
    var countFull = areaListBathroom
      .map((i) => i.isOccupied)
      .filter((item) => item === false).length;
    let Bathroom = null;
    if (bathroomCount) {
      Bathroom = (
        <AreaItem
          isKioskMode={this.props.isKioskMode}
          activeItem={this.state.activeDeviceType === AreaTypes.BATHROOM}
          mainIcon={faCharCodes.faRestroom} //ue016
          mainIconColor={Theme.COLORS.DEVICE_TYPES.BATHROOM} // "#8FE3CF" // ccc
          // mainIconRotate={"180deg"}
          caption={translate("v2Dashboard.wc")}
          // statusColor={bathroomCount == 1 && ArTheme.COLORS.SUCCESS}
          statusColor={
            areaListBathroom.length === 1 &&
            areaListBathroom[0]?.extra?.isOutOfService
              ? Theme.COLORS.MUTED
              : areaListBathroom[0]?.isOccupied
              ? Theme.COLORS.ERROR
              : Theme.COLORS.SUCCESS
          }
          count={bathroomCount}
          countFull={countFull}
          onCounterPress={() => {
            bathroomCount !== 1 &&
              this.handleOnItemAreaTypeCounterPress(AreaTypes.BATHROOM);
          }}
          // subIconStyle={{ top: -5 }}
        />
      );
    }

    // set background color
    var _backgroundStyle = {};
    if (this.props.area.isBreached) {
      _backgroundStyle = style.wrapperBreachedExpanded;
    } else if (this.props.area.isArmed) {
      if (this.state.expanded) _backgroundStyle = style.wrapperArmedExpanded;
      else _backgroundStyle = style.wrapperArmed;
    } else if (this.state.expanded) {
      _backgroundStyle = style.wrapperExpanded;
    }
    // end background color
    if (this.props.isKioskMode) {
      if (
        !Lights &&
        !Blinds &&
        !HVACs &&
        !Outlets &&
        !Switches &&
        !WateringSwitches &&
        !Locks &&
        !AccessControls &&
        !cameraDoorlocks &&
        !Cameras &&
        !Elevators &&
        !SmartSpeakers &&
        !Sensors &&
        !Sirens &&
        !powerMeters &&
        !Bathroom
      ) {
        return (
          <View
            style={{
              height: HEIGHT_CONTAINER,
              // flex: 1,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text style={{ fontWeight: "bold" }}>
              {translate("app.emptyList")}
            </Text>
          </View>
        );
      }
      return (
        <HStack space="4" style={{ margin: 15 }}>
          {/* === Device List === */}
          {/* {!this.hasOneDeviceType(
            Lights,
            Blinds,
            HVACs,
            Outlets,
            Switches,
            WateringSwitches,
            Locks,
            AccessControls,
            cameraDoorlocks,
            Cameras,
            Elevators,
            SmartSpeakers,
            Sensors,
            Sirens,
            powerMeters,
            Bathroom
          ) ? (
         
          ) : (
            ""
          )} */}
          <View style={style.deviceBarContainer}>
            <ScrollView>
              <VStack
                space="4"
                style={{
                  height: "100%",
                  flex: 1,
                }}
              >
                {/* device groups with bach action */}
                {Lights}
                {Blinds}
                {HVACs}
                {Outlets}
                {Switches}
                {WateringSwitches}
                {/* end of device groups with bach action */}

                {/* device groups without bach action */}
                {Locks}
                {AccessControls}
                {cameraDoorlocks}
                {Cameras}
                {Elevators}
                {SmartSpeakers}
                {Sensors}
                {Sirens}
                {powerMeters}
                {Bathroom}
              </VStack>
            </ScrollView>
          </View>
          <View style={[style.deviceDetailContainer, { position: "relative" }]}>
            {/* === ARM and isBreached Icon - background === */}
            {/* {(this.props.area.isArmed || this.props.area.isBreached) && (
              <View 
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <FontAwesomeIcon
                  icon={
                    this.props.area.isBreached
                      ? faCharCodes.faExclamationTriangle
                      : this.props.area.isArmed && faCharCodes.faShieldCheck
                  }
                  size={70}
                  color={
                    this.props.area.isBreached
                      ? Theme.COLORS.ERROR
                      : Theme.COLORS.ORANGE
                  }
                  // style={{ marginEnd: 5, marginTop: 8 }}
                />
              </View>
            )} */}
            {/* === Header === */}
            {this.renderHeaderArea()}
            <HStack space="2">
              {/* rtsp camera */}
              {selectedCamera}
              {/* music player */}
              {SelectedSpeaker}
            </HStack>
            {/* === Device Detail === */}
            <ImageBackground
              style={{
                flex: 1,
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 30,
              }}
              resizeMethod="cover"
              source={
                this.props.area.imageSource
                  ? { uri: this.props.area.imageSource }
                  : null
                // : require("../../assets/images/noimage.png")
              }
            >
              <ScrollView style={{ flex: 1 }}>{this.props.children}</ScrollView>
            </ImageBackground>
          </View>
        </HStack>
      );
    }
    return (
      <View
        style={[
          style.wrapper,
          _backgroundStyle,
          {
            ...this.props.style,
          },
          this.props.isKioskMode && {
            backgroundColor: "transparent",
            shadowColor: "transparent",
            elevation: 0,
            marginTop: 0,
          },
          this.props.area.armReport &&
            Number(this.props.area.armReport.countDown) > 0 &&
            !this.props.isKioskMode && {
              borderWidth: 1,
              borderColor: "#ff84005c",
            },
        ]}
      >
        {/* === Icon Expanded === */}
        {!this.props.emptyArea && !this.props.isKioskMode && (
          <IconButton
            onPress={() => {
              this.setState({ expanded: !this.state.expanded });
            }}
            style={[
              style.expandedIcon,
              IS_MOBILE
                ? {
                    right: 0,
                    borderBottomRightRadius: 10,
                    borderTopLeftRadius: 10,
                  }
                : getIsRTL()
                ? {
                    left: 0,
                    borderBottomLeftRadius: 10,
                    borderTopRightRadius: 10,
                  }
                : {
                    right: 0,
                    borderBottomRightRadius: 10,
                    borderTopLeftRadius: 10,
                  },
            ]}
            icon={{
              code: this.state.expanded
                ? faCharCodes.faAngleDoubleUp
                : faCharCodes.faAngleDoubleDown,
              style: {
                fontFamily: "FontAwesomeProLight",
                fontSize: 10,
                color: Theme.COLORS.DARK,
              },
            }}
          />
        )}
        {/* === new QA === */}
        {!this.props.isKioskMode && (
          <View
            style={[
              {
                backgroundColor: Theme.COLORS.WHITE,
                minWidth: 90,
                // height: 30,
                // paddingVertical:5,
                position: "absolute",
                top: 0,
                borderRadius: 3,
                shadowColor: Theme.COLORS.BACKGROUND,
                shadowOffset: {
                  width: 0,
                  height: 2,
                },
                shadowOpacity: 0.3,
                shadowRadius: 6.65,
                elevation: 3,

                zIndex: 1,
              },
              IS_MOBILE
                ? {
                    right: 0,
                    borderBottomLeftRadius: 10,
                    borderTopRightRadius: 10,
                  }
                : getIsRTL()
                ? {
                    left: 0,
                    borderBottomRightRadius: 10,
                    borderTopLeftRadius: 10,
                  }
                : {
                    right: 0,
                    borderBottomLeftRadius: 10,
                    borderTopRightRadius: 10,
                  },
            ]}
          >
            <View
              style={{
                flexDirection: "row-reverse",
                alignItems: "center",
                justifyContent: "space-evenly",
              }}
            >
              {/* lights */}
              {!this.props.area.isArmed &&
                !this.state.expanded &&
                this.props.area.lights > 0 && (
                  <IconButton
                    onPress={() =>
                      this.handleOnItemCounterPress(DeviceTypes.LIGHT)
                    }
                    icon={{
                      code: faCharCodes.faLightbulb,
                      style: {
                        fontFamily: "FontAwesomeProLight",
                        fontSize: 18,
                        color: "#ffcc00",
                      },
                    }}
                    style={[
                      style.titleDevice,
                      {
                        borderColor: "#ffcc00",
                        // backgroundColor: "#fffbeb",
                      },
                    ]}
                  />
                )}
              {/* doorLocks */}
              {!this.props.area.isArmed &&
                !this.state.expanded &&
                this.props.area.locks > 0 && (
                  <IconButton
                    onPress={this.handleOnDoorLockPress}
                    icon={{
                      code: faCharCodes.faKey,
                      style: {
                        fontFamily: "FontAwesomeProLight",
                        fontSize: 18,
                        // color: "#666699",
                      },
                    }}
                    style={[
                      style.titleDevice,
                      {
                        borderColor: "#666699",
                        // backgroundColor: "#f0f0ff",
                      },
                    ]}
                  />
                )}
              {/* accessControls */}

              {/* cameras */}
              {this.props.area.isArmed &&
                !this.state.expanded &&
                this.props.area.cameras > 0 &&
                IS_MOBILE && (
                  <IconButton
                    onPress={() =>
                      this.handleOnItemCounterPress(DeviceTypes.CAMERA)
                    }
                    icon={{
                      code: faCharCodes.faCctv,
                      style: {
                        fontFamily: "FontAwesomeProLight",
                        fontSize: 18,
                        color: "#cc9966",
                      },
                    }}
                    style={[
                      style.titleDevice,
                      {
                        borderColor: "#cc9966",
                        // backgroundColor: "#f7efe6",
                      },
                    ]}
                  />
                )}
            </View>
          </View>
        )}
        {/* main wrapper */}
        {/* add overflow hidden to hide arm big icon when area is empty (area height is shorter than bigArmIcon) */}
        <View
          style={{
            overflow: "hidden",
          }}
        >
          {/* Area Title */}
          <View
            style={[
              style.areaTitle,
              // this.props.isKioskMode && {
              //   backgroundColor: ArTheme.COLORS.WHITE,
              //   borderRadius: 10,
              //   marginBottom: 10,
              //   paddingHorizontal: 10,
              // },
            ]}
          >
            {/* Area Name */}
            <View
              style={{
                flexDirection: "column",
                alignItems: "flex-start",
                flex: 1,
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  minHeight: 45,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  {/* state button */}
                  {!this.props.isKioskMode && (
                    <View
                      style={[
                        {
                          flexDirection: "row",
                          borderColor: Theme.COLORS.BORDER_COLOR,
                          borderRadius: 10,
                          borderWidth: 1,
                        },
                        this.props.area.isBreached
                          ? style.breachedModeContainer
                          : this.props.area.isArmed && style.safeModeContainer,
                      ]}
                    >
                      {this.props.area.isArmed != null &&
                      this.props.area.isArmed
                        ? Armed
                        : AreaState || Armed}
                      {/* area states list */}
                      {this.props.showAreaState && (
                        <TouchableHighlight
                          underlayColor="transparent"
                          style={{
                            marginHorizontal: 5,
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                          onPress={() => {
                            this.props.onShowAreaStateRBSheet &&
                              this.props.onShowAreaStateRBSheet();
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faCharCodes.faAngleDown}
                            size={15}
                            color={Theme.COLORS.BORDER}
                            // style={{ marginEnd: 5, marginTop: 8 }}
                          ></FontAwesomeIcon>
                        </TouchableHighlight>
                      )}
                    </View>
                  )}
                  {/* end area states */}
                  <View>
                    <View
                    // style={{ flexDirection: "row", alignItems: "center" }}
                    >
                      <Text
                        onPress={() => {
                          !this.props.isKioskMode
                            ? this.setState({ expanded: !this.state.expanded })
                            : null;
                        }}
                        style={{ fontSize: 16, paddingHorizontal: 10 }}
                      >
                        {this.props.area.areaName}{" "}
                      </Text>
                      {(this.props.area.isArmed ||
                        this.props.area.isBreached) &&
                        !this.props.isKioskMode && (
                          <Text
                            style={{
                              fontSize: 8,
                              marginTop: 0,
                              paddingHorizontal: 10,
                            }}
                          >
                            (
                            {this.props.area.isBreached
                              ? translate("area.isBreached")
                              : this.props.area.isArmed &&
                                translate("area.isArm")}
                            )
                          </Text>
                        )}
                    </View>
                    {/* area state name  */}

                    {areaStateText != null && (
                      <Text
                        style={{
                          // marginTop: 3,
                          color: Theme.COLORS.PLACEHOLDER,
                          fontSize: 12,
                          marginHorizontal: 10,
                        }}
                      >
                        {translate("app.status")}
                        {":"} {areaStateText}
                      </Text>
                    )}
                  </View>
                </View>
                {/* === Thermometer & LightMeter */}
                {this.state.expanded && (
                  <View
                    style={{
                      flexDirection: "row-reverse",
                      justifyContent: "space-between",
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "row-reverse",
                        alignItems: "center",
                        // paddingTop: 10,
                      }}
                    >
                      {/* thermometer */}
                      <Thermometer
                        areaId={this.props.areaId}
                        areaUId={this.props.areaUId}
                        style={style.titleSensorThermometer}
                      />
                      {/* lightMeter */}
                      <LightMeter
                        areaId={this.props.areaId}
                        areaUId={this.props.areaUId}
                        style={style.titleSensor}
                      />
                    </View>
                  </View>
                )}
              </View>
            </View>
          </View>
          {this.props.area.armReport &&
            Number(this.props.area.armReport.countDown) > 0 &&
            !this.props.isKioskMode && (
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginHorizontal: 15,
                  top: -10,
                }}
              >
                <Text style={{ textAlign: "right" }}>
                  {translate("area.willArmAfterCountDown")}
                </Text>
                <Countdown
                  until={this.props.area.armReport.countDown}
                  size={20}
                  digitStyle={{
                    backgroundColor: "#FFFFFF00",
                    paddingTop: 15,
                  }}
                  timeLabelStyle={{ color: "grey" }}
                  timeToShow={["S"]}
                  timeLabels={{
                    s: translate("timer.seconds"),
                  }}
                  onChange={(e) => {
                    if (e > 0 && !this.state.armCountDownStarted) {
                      this.setState({ armCountDownStarted: true });
                    } else if (this.state.showArmModal) {
                      setTimeout(() => {
                        this.setState({ showArmModal: false });
                      }, 100);
                    }
                  }}
                  onFinish={() => {
                    setTimeout(this.hideArmModal, 500);
                  }}
                  showSeparator={false}
                />
              </View>
            )}
          {this.props.area.isArmed && this.state.expanded && (
            <IconButton
              style={{
                position: "absolute",
                top: 0,
                bottom: 0,
                justifyContent: "center",
                alignSelf: "center",
                opacity: 0.2,
              }}
              icon={{
                code: this.props.area.isBreached
                  ? faCharCodes.faExclamationTriangle
                  : this.props.area.isArmed
                  ? faCharCodes.faShieldCheck
                  : faCharCodes.faShield,
                style: {
                  color: this.props.area.isBreached
                    ? Theme.COLORS.ERROR
                    : Theme.COLORS.ORANGE,
                  fontFamily: faCharCodes.FONT_FAMILIES.PRO_REGULAR,
                  fontSize: BIG_ARM_CION_SIZE,
                  transform: [{ rotate: "0deg" }],
                },
              }}
            />
          )}
          {/* rtsp camera */}
          {selectedCamera}
          {/* music player */}
          {SelectedSpeaker}
          {/* Area Items */}
          {this.state.expanded && (
            <View
              style={{
                flex: 1,
                flexDirection: "row",
                justifyContent: "space-around",
                flexWrap: "wrap",
                marginBottom: 12,
                // borderBottomColor: "#669999",
                // borderBottomWidth: 1,
              }}
            >
              {/* device groups with bach action */}
              {Lights}
              {Blinds}
              {HVACs}
              {Outlets}
              {Switches}
              {WateringSwitches}
              {/* end of device groups with bach action */}

              {/* device groups without bach action */}
              {Locks}
              {AccessControls}
              {cameraDoorlocks}
              {Cameras}
              {Elevators}
              {SmartSpeakers}
              {Sensors}
              {Sirens}
              {powerMeters}
              {Bathroom}
              {/* end of device groups without bach action */}
            </View>
          )}
        </View>
        {/* Arm modal */}
        {this.state.showArmModal && (
          <ModalBase
            header={
              (this.props.area.armReport &&
                this.props.area.armReport.inProgress) ||
              !this.props.area.isArmed
                ? translate("area.activatingArm")
                : null
            }
            isOpen={this.state.showArmModal}
            onClose={() => this.hideArmModal()}
            // contentStyle={{ height: "100%" }}
          >
            <ScrollView
              style={{ flex: 1 }}
              contentContainerStyle={{ flex: 1, padding: 5 }}
              // style={style.modalInsideWrapper}
            >
              {this.renderArmModal()}
              {/* end close button */}
            </ScrollView>
          </ModalBase>
        )}
      </View>
    );
  }
}

const style = StyleSheet.create({
  modalBtn: {
    flex: 1,
    height: 40,
    marginBottom: 0,
    alignSelf: "center",
  },
  modalInsideWrapper: {
    backgroundColor: "#FFF",
    borderRadius: 15,
    flex: 1,
    margin: 20,
    paddingTop: 15,
    borderColor: Theme.COLORS.BORDER,
    borderWidth: 1,
    alignSelf: "center",
    paddingHorizontal: 10,
    height: "100%",
  },
  areaImage: {
    width: IMAGE_SIZE,
    height: IMAGE_SIZE,
    borderRadius: IMAGE_SIZE / 2,
    marginHorizontal: 5,
    resizeMode: "cover",
    borderColor: "#FFF",
    borderWidth: 3,
  },
  titleSensor: {
    paddingEnd: 7,
  },
  titleSensorThermometer: {
    paddingEnd: 7,
    // borderLeftWidth: 1,
  },
  titleDevice: {
    paddingVertical: 8,
    // marginHorizontal: 5,
    // marginRight: 15,
    // borderWidth: 1,
    // width: 40,
    // height: 40,
    // borderRadius: 20,
    justifyContent: "center",
  },
  armOption: {
    flex: 1,
    padding: 5,
    // justifyContent: "center",
    backgroundColor: "#f2f2f2",
    borderColor: Theme.COLORS.BORDER_COLOR,
    borderWidth: 1,
    borderRadius: 5,
    marginBottom: 10,
  },
  areaItem: {
    width: (SCREEN_WIDTH - 60) / 2,
    marginBottom: 15,
  },
  wrapper: {
    marginVertical: 8,
    padding: 10,
    borderRadius: 10,
    backgroundColor: Theme.COLORS.GRAY_LIGHT,

    shadowColor: Theme.COLORS.MUTED,
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.2,
    shadowRadius: 6.65,
    elevation: 4,
    // borderColor: "#e4e4e4",
    // borderWidth: 1,
    // maxWidth: CONSTANTS.WEB_MAX_WIDTH - 30,
  },
  wrapperExpanded: {
    backgroundColor: "#FFF", // EAEAEA
  },
  wrapperArmed: {
    backgroundColor: "#f3ece4",
  },
  wrapperArmedExpanded: {
    backgroundColor: "#f3ece4",
  },
  wrapperBreachedExpanded: {
    backgroundColor: Theme.COLORS.ERROR + "15",
  },

  areaItemActionWrapper: {
    width: 35,
    alignItems: "center",
    justifyContent: "flex-start",
  },
  areaTitle: {
    // flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    minHeight: 50,

    paddingVertical: 10,
    // marginVertical: IS_MOBILE ? 5 : 15,
  },
  mediaPlayerContainer: {
    // flex: 1,
    width: "100%",
    margin: 5,
    marginTop: 5,
    marginBottom: 25,
    paddingHorizontal: 10,
    borderRadius: 3,
  },
  boxShadowPrimary: {
    shadowColor: Theme.COLORS.PRIMARY,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6.65,
    elevation: 9,
  },
  safeModeContainer: {
    // width: 45,
    // height: 45,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: Theme.COLORS.ORANGE,
    shadowColor: Theme.COLORS.ORANGE,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6.65,
    elevation: 9,
  },
  breachedModeContainer: {
    // width: 45,
    // height: 45,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: Theme.COLORS.ERROR,
    shadowColor: Theme.COLORS.ERROR,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6.65,
    elevation: 9,
  },
  expandedIcon: {
    position: "absolute",
    bottom: 0,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: Theme.COLORS.WHITE,
    padding: 5,
    width: 30,
    zIndex: 1,
    height: 30,
    shadowColor: Theme.COLORS.BACKGROUND,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6.65,
    elevation: 3,
  },
  deviceBarContainer: {
    width: 100,
    backgroundColor: Theme.COLORS.WHITE,
    borderRadius: 10,
    padding: 10,
    height: HEIGHT_CONTAINER,
  },
  deviceBarContainer: {
    width: 100,
    backgroundColor: Theme.COLORS.WHITE,
    borderRadius: 10,
    padding: 10,
    height: HEIGHT_CONTAINER,
  },
  deviceDetailContainer: {
    borderRadius: 10,
    backgroundColor: Theme.COLORS.WHITE,
    padding: 15,
    width: "100%",
    flexShrink: 1,
    height: HEIGHT_CONTAINER,
  },
});

const mapStateToProps = (state) => {
  return {
    DeviceReducer: state.DeviceReducer,
    AreaReducer: state.AreaReducer,
    ScenarioReducer: state.ScenarioReducer,
    AppReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    turnOnAllLights: (areaId, areaUId, accessToken) =>
      dispatch(AreaActions.changeLights(areaId, areaUId, true, accessToken)),
    turnOffAllLights: (areaId, areaUId, accessToken) =>
      dispatch(AreaActions.changeLights(areaId, areaUId, false, accessToken)),
    turnOnAllOutlets: (areaId, areaUId, accessToken) =>
      dispatch(AreaActions.changeOutlets(areaId, areaUId, true, accessToken)),
    turnOffAllOutlets: (areaId, areaUId, accessToken) =>
      dispatch(AreaActions.changeOutlets(areaId, areaUId, false, accessToken)),
    turnOnAllSirens: (areaId, areaUId, accessToken) =>
      dispatch(AreaActions.changeSirens(areaId, areaUId, true, accessToken)),
    turnOffAllSirens: (areaId, areaUId, accessToken) =>
      dispatch(AreaActions.changeSirens(areaId, areaUId, false, accessToken)),
    turnOnAllSwitches: (areaId, areaUId, accessToken) =>
      dispatch(
        AreaActions.changePowerSwitches(areaId, areaUId, true, accessToken)
      ),
    turnOffAllSwitches: (areaId, areaUId, accessToken) =>
      dispatch(
        AreaActions.changePowerSwitches(areaId, areaUId, false, accessToken)
      ),
    turnOnAllWateringSwitches: (areaId, areaUId, accessToken) =>
      dispatch(
        AreaActions.changeWateringSwitches(areaId, areaUId, true, accessToken)
      ),
    turnOffAllWateringSwitches: (areaId, areaUId, accessToken) =>
      dispatch(
        AreaActions.changeWateringSwitches(areaId, areaUId, false, accessToken)
      ),
    openAllCurtains: (areaId, areaUId, accessToken) =>
      dispatch(AreaActions.openCurtains(areaId, areaUId, accessToken)),
    closeAllCurtains: (areaId, areaUId, accessToken) =>
      dispatch(AreaActions.closeCurtains(areaId, areaUId, accessToken)),

    turnOnAllHVAC: (areaId, areaUId, accessToken) =>
      dispatch(AreaActions.changeHVACs(areaId, areaUId, true, accessToken)),
    turnOffAllHVAC: (areaId, areaUId, accessToken) =>
      dispatch(AreaActions.changeHVACs(areaId, areaUId, false, accessToken)),
    unlockDoorLock: (deviceId, deviceUId, accessToken) =>
      dispatch(DoorlockActions.Unlock(deviceId, deviceUId, accessToken)),
    Arm: (
      areaId,
      areaUId,
      accessToken,
      shouldTurnOffLights,
      shouldTurnOffAirConditioners,
      shouldCheckDoorWindowsClosed,
      shouldCloseCurtains,
      shouldNotifyBreach,
      shouldSmsBreach,
      shouldRunScenarios,
      shouldTurnOnSirens,
      sirensDuration
    ) =>
      dispatch(
        AreaActions.arm(
          areaId,
          areaUId,
          accessToken,
          shouldTurnOffLights,
          shouldTurnOffAirConditioners,
          shouldCheckDoorWindowsClosed,
          shouldCloseCurtains,
          shouldNotifyBreach,
          shouldSmsBreach,
          shouldRunScenarios,
          shouldTurnOnSirens,
          sirensDuration
        )
      ),
    Disarm: (
      areaId,
      areaUId,
      accessToken,
      shouldUnlockAfterDisArm,
      devicesToUnlockAfterDisArm
    ) =>
      dispatch(
        AreaActions.disarm(
          areaId,
          areaUId,
          accessToken,
          shouldUnlockAfterDisArm,
          devicesToUnlockAfterDisArm
        )
      ),
    ResetArmReport: (areaId) =>
      dispatch(AreaActions.resetLocalArmReport(areaId)),

    // smart speaker
    GetSpeakerState: (areaId, areaUId, deviceId, deviceUId, accessToken) =>
      dispatch(
        SmartSpeakerActions.State(
          areaId,
          areaUId,
          deviceId,
          deviceUId,
          accessToken
        )
      ),
    ResetSpeakerSeekBar: (deviceId, deviceUId) =>
      dispatch(SmartSpeakerActions.ResetSeekLocally(deviceId, deviceUId)),
    PlaySpeaker: (
      areaId,
      areaUId,
      deviceId,
      deviceUId,
      playListId,
      playListUId,
      trackId,
      accessToken
    ) =>
      dispatch(
        SmartSpeakerActions.Play(
          areaId,
          areaUId,
          deviceId,
          deviceUId,
          playListId,
          playListUId,
          trackId,
          accessToken
        )
      ),
    ResumeSpeaker: (
      areaId,
      areaUId,
      deviceId,
      deviceUId,
      playListId,
      playListUId,
      trackId,
      accessToken
    ) =>
      dispatch(
        SmartSpeakerActions.Resume(
          areaId,
          areaUId,
          deviceId,
          deviceUId,
          playListId,
          playListUId,
          trackId,
          accessToken
        )
      ),
    PauseSpeaker: (areaId, areaUId, deviceId, deviceUId, accessToken) =>
      dispatch(
        SmartSpeakerActions.Pause(
          areaId,
          areaUId,
          deviceId,
          deviceUId,
          accessToken
        )
      ),
    StopSpeaker: (areaId, areaUId, deviceId, deviceUId, accessToken) =>
      dispatch(
        SmartSpeakerActions.Stop(
          areaId,
          areaUId,
          deviceId,
          deviceUId,
          accessToken
        )
      ),
    NextSpeakerTrack: (areaId, areaUId, deviceId, deviceUId, accessToken) =>
      dispatch(
        SmartSpeakerActions.Next(
          areaId,
          areaUId,
          deviceId,
          deviceUId,
          accessToken
        )
      ),
    PreviousSpeakerTrack: (areaId, areaUId, deviceId, deviceUId, accessToken) =>
      dispatch(
        SmartSpeakerActions.Previous(
          areaId,
          areaUId,
          deviceId,
          deviceUId,
          accessToken
        )
      ),
    SeekSpeaker: (
      areaId,
      areaUId,
      deviceId,
      deviceUId,
      targetPosition,
      accessToken
    ) =>
      dispatch(
        SmartSpeakerActions.Seek(
          areaId,
          areaUId,
          deviceId,
          deviceUId,
          targetPosition,
          accessToken
        )
      ),
    ChangeSpeakerVolume: (
      areaId,
      areaUId,
      deviceId,
      deviceUId,
      volume,
      group,
      accessToken
    ) =>
      dispatch(
        SmartSpeakerActions.ChangeVolume(
          areaId,
          areaUId,
          deviceId,
          deviceUId,
          volume,
          group,
          accessToken
        )
      ),
    ToggleSpeakerMute: (
      areaId,
      areaUId,
      deviceId,
      deviceUId,
      mute,
      group,
      accessToken
    ) =>
      dispatch(
        SmartSpeakerActions.ToggleMute(
          areaId,
          areaUId,
          deviceId,
          deviceUId,
          mute,
          group,
          accessToken
        )
      ),
    SetSmartSpeakerInput: (
      areaId,
      areaUId,
      deviceId,
      deviceUId,
      input,
      accessToken
    ) =>
      dispatch(
        SmartSpeakerActions.SetInput(
          areaId,
          areaUId,
          deviceId,
          deviceUId,
          input,
          accessToken
        )
      ),
    updateSlaveSmartSpeaker: (masterDeviceUId, slaveDeviceUId, status) =>
      dispatch(
        SmartSpeakerActions.updateSlaveSmartSpeaker(
          masterDeviceUId,
          slaveDeviceUId,
          status
        )
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(Area);
